import {
  FormControl,
  FormHelperText,
  Grid,
  TextField,
  Typography,
  Button,
  Autocomplete,
  Divider,
} from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import HeaderPage from "../../components/HeaderPage/Index";
import { isMobile } from "react-device-detect";
import {
  checkIdcard,
  formatterIdCard,
  fomatterNumber,
  fomatterEN,
  fomatterTH,
} from "../../utils/formatter";
import {
  getData,
  storeData,
  checkEditPage,
  callChoice,
} from "../../utils/GlobalHelper";
import Loading from "../../components/loading/loading";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import ScrollBarComponent from "../../components/BoxRightContent/ScrollBarComponent";
import ButtonRight from "../../components/BoxRightContent/ButtonRight";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import DialogWait from "../../components/CustomDialog/DialogWait";
import CustomDropDownList from "../../components/BoxRightContent/CustomDropDownList";
import DialogCustoms from "../../components/CustomDialog/DialogCustoms";
import Configs from "../../constants/Configs";
import GlobalApi from "../../utils/GlobalApi";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import { API_CODE_SUCCESS } from "../../constants/CommonConstant";
import { isEmpty } from "lodash";
import qs from "qs";
const header = {
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
    Accept: "application/json",
  },
};
const useStyle = makeStyles({
  textPhone: {
    paddingRight: "5px",
    color: "var(--text-black)",
  },
  textPrimary: {
    fontFamily: "DB Heavent",
    color: "var(--primary)",
  },
  textError: {
    fontSize: "16px !important",
    fontFamily: "DB Heavent !important",
    color: "var(--red) !important",
  },
});
const Married = (props) => {
  const classes = useStyle();
  const mb = isMobile ? 16 : 9;
  const idc = getData("idc");
  const childList = getData("childList");
  const [lang, setLang] = useState("");
  const [translations, setTranslations] = useState("");
  const [en, setEn] = useState({});
  const [th, setTh] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isBtnCheck, setIsBtnCheck] = useState(false);
  const [isSingle, setSingle] = useState(false);
  const [prefixs, setprefixs] = useState("");
  const [isModelWait, setIsModelWait] = useState(false);
  const [isModel, setIsModel] = useState(false);
  const [checked, setChecked] = useState(false);
  const head_token = getData("HeaderManp")
    ? getData("HeaderManp")?.head_token
    : "";
  const currentPage = getData("currentStep");
  const [editUrl, setEditUrl] = useState(false);
  /* body val */
  const [f1_marital_status_val, set_f1_marital_status] = useState("");
  const [f1_spouse_is_th_val, set_f1_spouse_is_th] = useState("");
  const [f1_spouse_title_val, set_f1_spouse_title] = useState("");
  const [f1_spouse_text_title_val, set_f1_spouse_text_title] = useState("");

  const [f1_spouse_firstname_val, set_f1_spouse_firstname] = useState("");
  const [f1_spouse_lastname_val, set_f1_spouse_lastname] = useState("");
  const [f1_spouse_firstname_en_val, set_f1_spouse_firstname_en] = useState("");
  const [f1_spouse_lastname_en_val, set_f1_spouse_lastname_en] = useState("");
  const [f1_spouse_id_card_val, set_f1_spouse_id_card] = useState("");
  const [headToken, setHeadToken] = useState(head_token);

  const [message_error, set_message_error] = useState("");
  const [localData, setLocalData] = useState("");

  /* init defult data */

  const [prefix, setprefix] = useState("");
  const [value, setValue] = React.useState("");
  const [valueSpouse, setValueSpouse] = React.useState("");
  const [isSpouseThai, setisSpouseThai] = React.useState(false);
  const [isSpouseAbroad, setisSpouseAbroad] = React.useState(false);
  const [isEnabled, setIsEnabled] = useState(false);
  const [isCheckIdcard, setIscheckIdcard] = useState(false);
  const [cardId, setCardId] = useState("");
  const [cardIdError, setCardIdError] = useState("");

  /* input copper thai */
  const [textIdendityCard, setTextIdendityCard] = useState("");
  const [textNameThai, setTextNameThai] = useState("");
  const [textLastNameThai, setTextLastNameThai] = useState("");
  const [textNameThaiEn, setTextNameThaiEn] = useState("");

  const [titleThai, setTitleThai] = useState("");
  const [textLastNameThaiEn, setTextLastNameThaiEn] = useState("");

  /* input copper aboard */
  const [textPassport, setTextPassport] = useState("");
  const [textNameAboard, setTextNameAboard] = useState("");
  const [titleEn, settitleEn] = useState("");

  const [titleAboard, setTitleAboard] = useState("");
  const [textLastNameAboard, setTextLastNameAboard] = useState("");

  /*text error*/
  const [textLastNameThaiError, setTextLastNameThaiError] = useState("");
  const [textIdendityCardError, setIdendityCardError] = useState("");
  const [textNameThaiError, setTextNameThaiError] = useState("");
  const [textNameThaiEnError, setTextNameThaiEnError] = useState("");
  const [textLastNameThaiEnError, setTextLastNameThaiEnError] = useState("");
  const [titleTHError, setTitleTHError] = useState("");
  const [titleTextTHError, setTitleTextTHError] = useState("");

  const [textPassportError, setTextPassportError] = useState("");
  const [textNameAboardError, setTextNameAboardError] = useState("");
  const [textLastNameAboardError, setTextLastNameAboardError] = useState("");
  const [titleENError, setTitleENError] = useState("");
  const [titleTextENError, setTitleTextENError] = useState("");

  const [jumpPage, setJumpPage] = useState(false);
  const checkuserinfo = getData("checkuserinfo");
  const questions = getData("questionsAnswer");
  const pageAgree = getData("page_agree");
  const idcAddr = getData("f2_idc_address");
  const curAddr = getData("f2_current_address");
  const workAddr = getData("f2_workplace_address");
  const docAddr = getData("f2_document_address");
  const suit = getData("suitability");
  const career = getData("f3_career");
  let snapIdCard = getData("uploadImage");

  const checkJumpPage = async () => {
    await getImage();
    let productChoice = false;
    await callChoice(head_token).then((res) => {
      if (!isEmpty(res)) {
        res.forEach((e) => {
          e.items.forEach((item) => {
            if (item.selected === 1) productChoice = true;
          });
        });
      }
    });

    if (
      isEmpty(checkuserinfo) ||
      isEmpty(questions) ||
      isEmpty(pageAgree) ||
      pageAgree.termandcon !== 1 ||
      pageAgree.pdpa !== 1 ||
      isEmpty(snapIdCard) ||
      isEmpty(idc) ||
      isEmpty(idcAddr) ||
      isEmpty(curAddr) ||
      isEmpty(workAddr) ||
      isEmpty(docAddr) ||
      isEmpty(career) ||
      !productChoice ||
      isEmpty(suit)
    ) {
      return true;
    } else {
      return false;
    }
  };
  const getImage = async () => {
    setIsLoading(true);
    var postData = {
      head_token,
    };
    const queryString = new URLSearchParams(postData).toString();
    let getImage_url = `${Configs.baseURL}/api/getupload?` + queryString;
    try {
      await GlobalApi.get(getImage_url, header)
        .then(async (res) => {
          setIsLoading(false);
          if (res.data.api_status === "1") {
            if (res.data.data.length > 0) {
              res.data.data.forEach((element) => {
                if (element.tb_image_page === "uploadImage") {
                  snapIdCard = element.tb_image_type + element.tb_image_base64;
                }
              });
            }
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
    return;
  };
  const checkEditUrl = async () => {
    checkEditPage().then((res) => {
      res ? setEditUrl(true) : setEditUrl(false);
    });
  };
  const apiLang = async (type) => {
    try {
      setIsLoading(true);
      await GlobalApi.get("/data/mock/" + type + "_response.json")
        .then((res) => {
          if (type === "en") {
            setEn(res?.data);
          } else if (type === "th") {
            setTh(res?.data);
          }
          setIsLoading(false);
        })
        .catch((er) => {
          setIsLoading(false);
          // console.log(er);
        });
    } catch (err) {
      setIsLoading(false);
      // console.log(err);
    }
  };

  const callGetTitle = async () => {
    setIsLoading(true);
    try {
      await GlobalApi.get(`${Configs.baseAPIURL03}/constant/title`)
        .then((res) => {
          setIsLoading(false);
          setprefixs(res?.data?.Data);
        })
        .catch((er) => {
          // console.log(er);
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
  };

  const callGetMaritalStatus = async () => {
    setIsLoading(true);
    try {
      await GlobalApi.get(`${Configs.baseAPIURL03}/constant/marital_status`)
        .then((res) => {
          setIsLoading(false);
          //setprefixs(JSON.stringify(res?.data?.Data));
        })
        .catch((er) => {
          // console.log(er);
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
  };
  const callPostStatus = async () => {
    checkEditPage().then((r) => {
      if (r) {
        setIsLoading(true);
        const family_status = getData("family_status");
        const data = {
          head_token,
          f1_marital_status: family_status.f1_marital_status,
          f1_spouse_title: family_status.f1_spouse_title,
          f1_spouse_is_th: family_status.f1_spouse_is_th,
          f1_spouse_firstname: family_status.f1_spouse_is_th
            ? family_status.f1_spouse_firstname
            : "",
          f1_spouse_lastname: family_status.f1_spouse_is_th
            ? family_status.f1_spouse_lastname
            : "",
          f1_spouse_title_text:
            family_status.f1_marital_status === "2" &&
            family_status.f1_spouse_title_text
              ? family_status.f1_spouse_title_text
              : "",
          f1_spouse_firstname_en: family_status.f1_spouse_firstname_en,
          f1_spouse_lastname_en: family_status.f1_spouse_lastname_en,
          f1_spouse_id_card: family_status.f1_spouse_id_card,
        };
        const header = {
          headers: {
            "Content-Type": "application/json",
          },
        };
        try {
          GlobalApi.post(
            `${Configs.baseAPIURL03}/form/family_status/manp`,
            data,
            header,
          )
            .then((res) => {
              setIsLoading(false);
              if (res.data.Data[0][0].IsSuccess === 1) {
                storeData("editPage", "status");
                props.history.push("/summary");
              }
            })
            .catch((e) => {
              set_message_error(e);
              setIsModelWait(true);
              setIsLoading(false);
            });
        } catch (error) {
          set_message_error(error);
          setIsModelWait(true);
          setIsLoading(false);
        }
      } else {
        props.history.push("/familystatuschild");
      }
    });
  };
  const handleNext = (e) => {
    setIsBtnCheck(true);
    if (isSingle) {
      const data = {
        f1_marital_status: "1",
        f1_spouse_is_th: true,
        f1_spouse_title: "",
        f1_spouse_firstname: "",
        f1_spouse_lastname: "",
        f1_spouse_firstname_en: "",
        f1_spouse_lastname_en: "",
        f1_spouse_id_card: "",
        header_token: headToken,
      };
      storeData("family_status", data);
      callPostStatus();
    } else {
      /* init val*/
      set_f1_spouse_is_th(isSpouseThai);

      if (!value) {
        set_message_error("กรุณาเลือก ข้อมูลคู่สมรส");
        setIsModelWait(true);
      }

      if (valueSpouse === "thai") {
        let valitdate = true;
        if (isEmpty(cardId)) {
          setCardIdError("กรุณาระบุหมายเลยขบัตรประชาชน");
          valitdate = false;
        } else {
          let val = cardId.replace(/[-]+/g, "");
          if (!checkCid(val)) {
            setCardIdError("กรุณาระบุเลขที่บัตรประจำตัวประชาชนให้ถูกต้อง");

            valitdate = false;
          } else {
            let check = 0;
            childList?.data?.forEach((element, i) => {
              if (element.cardId === val) check++;
            });
            if (idc?.idCard === val || check > 0) {
              setCardIdError("เลขบัตรประจำตัวประชาชนไม่ถูกต้อง");
              valitdate = false;
            } else {
              setCardIdError("");
            }
          }
        }
        if (isEmpty(textNameThai)) {
          setTextNameThaiError("กรุณาระบุชื่อ");

          valitdate = false;
        }
        if (isEmpty(textLastNameThai)) {
          setTextLastNameThaiError("กรุณาระบุนามสกุล");

          valitdate = false;
        }

        if (isEmpty(textNameThaiEn)) {
          setTextNameThaiEnError("กรุณาระบุชื่อ ภาษาอังกฤษ");

          valitdate = false;
        }
        if (isEmpty(textLastNameThaiEn)) {
          setTextLastNameThaiEnError("กรุณาระบุนามสกุล ภาษาอังกฤษ");

          valitdate = false;
        }

        if (isEmpty(valueAutoComplate)) {
          setTitleTHError("กรุณาเลือกคำนำหน้า");

          valitdate = false;
        }

        if (valueAutoComplate?.Other === 1 && isEmpty(titleThai)) {
          setTitleTextTHError("กรุณาใส่คำนำหน้า");

          valitdate = false;
        }

        if (valitdate) {
          const data = {
            f1_marital_status: "2",
            f1_spouse_is_th: true,
            f1_spouse_title: valueAutoComplate?.Id,
            f1_spouse_title_text: titleThai,
            f1_spouse_firstname: textNameThai,
            f1_spouse_lastname: textLastNameThai,
            f1_spouse_firstname_en: textNameThaiEn,
            f1_spouse_lastname_en: textLastNameThaiEn,
            f1_spouse_id_card: cardId.replace(/[-]+/g, ""),
            head_token: headToken,
          };
          storeData("family_status", data);
          callPostStatus();
        }
      } else {
        let valitdate = true;
        if (isEmpty(textPassport)) {
          setTextPassportError("กรุณาระบุหมายเลข พาสต์ปอต");

          valitdate = false;
        }

        if (isEmpty(textNameAboard)) {
          setTextNameAboardError("กรุณาระบุชื่อ");

          valitdate = false;
        }

        if (isEmpty(valueAutoComplateEN)) {
          setTitleENError("กรุณาเลือกคำนำหน้า");

          valitdate = false;
        }
        if (isEmpty(textLastNameAboard)) {
          setTextLastNameAboardError("กรุณาระบุนามสกุล");

          valitdate = false;
        }

        if (valueAutoComplateEN?.Other === 1 && isEmpty(titleAboard)) {
          setTitleTextENError("กรุณาใส่คำนำหน้า");

          valitdate = false;
        }
        if (valitdate) {
          const data = {
            f1_marital_status: "2",
            f1_spouse_is_th: false,
            f1_spouse_title: valueAutoComplateEN?.Id,
            f1_spouse_title_text: titleAboard,
            f1_spouse_firstname: "",
            f1_spouse_lastname: "",
            f1_spouse_firstname_en: textNameAboard,
            f1_spouse_lastname_en: textLastNameAboard,
            f1_spouse_id_card: textPassport,
            head_token: headToken,
          };
          storeData("family_status", data);
          callPostStatus();
        }
      }
    }
  };

  const initVal = () => {
    setIsLoading(true);
    const localDatas = getData("family_status");
    if (!isEmpty(localDatas)) {
      if (localDatas.f1_marital_status === "1") {
        setSingle(true);
        setValue("single");
        setChecked(true);
      } else {
        if (localDatas.f1_spouse_is_th == true) {
          let selectTitle = options.find(
            (e) => e.Id === localDatas.f1_spouse_title,
          );
          setisSpouseThai(true);
          setSingle(false);
          setisSpouseAbroad(false);
          setValue("married");
          setValueSpouse("thai");
          setValueAutoComplate(selectTitle);
          setTitleThai(localDatas.f1_spouse_title_text);
          setTextNameThai(localDatas.f1_spouse_firstname);
          setTextLastNameThai(localDatas.f1_spouse_lastname);
          setTextNameThaiEn(localDatas.f1_spouse_firstname_en);
          setTextLastNameThaiEn(localDatas.f1_spouse_lastname_en);
          setChecked(true);
          setCardId(formatterIdCard(localDatas.f1_spouse_id_card));
        }

        if (localDatas.f1_spouse_is_th == false) {
          let selectTitle = options.find(
            (e) => e.Id === localDatas.f1_spouse_title,
          );
          setisSpouseThai(false);
          setSingle(false);
          setisSpouseAbroad(true);
          setValue("married");
          setValueSpouse("abroad");
          setValueAutoComplateEN(selectTitle);
          setTitleAboard(localDatas.f1_spouse_title_text);
          setTextPassport(localDatas.f1_spouse_id_card);
          setTextNameAboard(localDatas.f1_spouse_firstname_en);
          setTextLastNameAboard(localDatas.f1_spouse_lastname_en);
          setChecked(true);
        }
      }
    } else {
      // console.log("emtyData");
    }
  };

  useEffect(() => {
    checkJumpPage().then((res) => {
      if (res) setJumpPage(true);
    });
  }, []);
  useEffect(() => {
    checkEditUrl();
    if (!isEmpty(en) && !isEmpty(th)) {
      storeData("Translations", { en: en, th: th });
      setTranslations({ en: en, th: th });
    }
  }, [en, th]);
  useEffect(() => {
    storeData("lang", "th");
    apiLang("th");
    apiLang("en");
    setLang("th");
    callGetMaritalStatus();
    callGetTitle();
    const translation = getData("Translations");
    if (!isEmpty(translation)) {
      setTranslations(translation);
    } else {
      props.history.push("/");
    }
    initVal();
  }, []);

  const options = [
    {
      Seq: 1,
      Id: "43",
      NameTH: "นาย",
      NameEN: "MR.",
      Other: 0,
    },
    {
      Seq: 2,
      Id: "41",
      NameTH: "นาง",
      NameEN: "MRS.",
      Other: 0,
    },
    {
      Seq: 3,
      Id: "42",
      NameTH: "นางสาว",
      NameEN: "MISS",
      Other: 0,
    },
    {
      Seq: 4,
      Id: "205",
      NameTH: "อื่นๆ",
      NameEN: "Other",
      Other: 1,
    },
  ];
  const [valueAutoComplate, setValueAutoComplate] = React.useState(
    options[0].NameTH,
  );
  const [valueAutoComplateEN, setValueAutoComplateEN] = React.useState(
    options[0].NameTH,
  );
  const [inputValue, setInputValue] = React.useState("");

  const [errorValidateText, setErrorVaildateText] = React.useState({
    cardId: "",
    aeCode: "",
    f0_mobile_phone: "",
    f0_email: "",
    f0_email_1: "",
  });

  /* lang */
  const single = lang === "en" ? "Single" : "โสด";
  const married = lang === "en" ? "Married" : "สมรส";
  const spouseThai = lang === "en" ? "Thai" : "สัญชาติไทย";
  const spouseAbroad = lang === "en" ? "Abroad" : "ต่างชาติ";
  const hitRequire = lang === "en" ? "Please specify" : "กรุณาระบุ";
  const titleSpouse = lang === "en" ? "Spouse Information" : "ข้อมูลคู่สมรส";
  const labelCardId =
    lang === "en" ? "ID card code" : "เลขที่บัตรประจำตัวประชาชน";
  const labelPrefix = lang === "en" ? "Prefix" : "คำนำหน้าชื่อ";
  const labelNameThai = lang === "en" ? "Firstname Thai" : "ชื่อ (ภาษาไทย)";
  const labelLastNameThai =
    lang === "en" ? "Lastname Thai" : "นามสกุล (ภาษาไทย)";
  const labelNameEng = lang === "en" ? "Firstname En" : "ชื่อ (ภาษาอังกฤษ)";
  const labelLastNameEng =
    lang === "en" ? "Lastname En" : "นามสกุล (ภาษาอังกฤษ)";
  const labelPassport = lang === "en" ? "Passport" : "หนังสือเดินทาง";

  const isMaride = false;

  const cardIdChange = async (val) => {
    val = val.replace(/[-]+/g, "").slice(0, 13);

    let isnum = /^\d+$/.test(val);
    if (val.length == 13 && isnum) {
      val = formatterIdCard(val);
      if (isBtnCheck) {
        if (!checkCid(val)) {
          setCardIdError("กรุณาระบุเลขที่บัตรประจำตัวประชาชนให้ถูกต้อง");
        } else {
          let check = 0;
          childList?.data?.forEach((element, i) => {
            if (element.cardId === val.replace(/[-]+/g, "")) check++;
          });
          if (idc?.idCard === val.replace(/[-]+/g, "") || check > 0) {
            setCardIdError("เลขบัตรประจำตัวประชาชนไม่ถูกต้อง");
          } else {
            setCardIdError("");
          }
        }
      }
      setCardId(val.replace(/[^0-9-]+/g, ""));
    } else {
      setCardId(val.replace(/[^0-9-]+/g, ""));
    }
  };

  const checkCid = (cid) => {
    var total = 0;
    var iPID;
    var chk;
    var Validchk;
    iPID = cid.replace(/-/g, "");
    Validchk = iPID.substr(12, 1);
    var j = 0;
    var pidcut;
    for (var n = 0; n < 12; n++) {
      pidcut = parseInt(iPID.substr(j, 1));
      total = total + pidcut * (13 - n);
      j++;
    }

    chk = 11 - (total % 11);

    if (chk == 10) {
      chk = 0;
    } else if (chk == 11) {
      chk = 1;
    }
    if (chk == Validchk) {
      setErrorVaildateText({
        ...errorValidateText,
        cardId: "",
      });
      return true;
    } else {
      return false;
    }
  };

  const prefixTextThaiAutherChange = (e) => {
    const val = e.target.value ? fomatterTH(e.target.value) : e.target.value;
    setTitleThai(val);
    if (!isEmpty(val)) {
      setIsEnabled(true);
      setTitleTextTHError("");
    } else {
      setIsEnabled(false);
    }
  };

  const prefixTextEnAutherChange = (e) => {
    const val = e.target.value
      ? e.target.value.replace(
          /[^a-zA-Zกขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุูเแโใไๅๆ็่้๊๋์]/g,
          "",
        )
      : e.target.value;
    setTitleAboard(val);
    if (!isEmpty(val)) {
      setIsEnabled(true);
      setTitleTextENError("");
    } else {
      setIsEnabled(false);
    }
  };

  const handleChangeTHTitle = (e, val) => {
    setValueAutoComplate(val);
    setTitleThai("");
    if (!isEmpty(val?.Id)) {
      setTitleTHError("");
    }
  };

  const handleChangeENTitle = (e, val) => {
    setValueAutoComplateEN(val);
    setTitleAboard("");

    if (!isEmpty(val?.Id)) {
      setTitleENError("");
    }
  };

  const handleChangeAboardLastName = (e) => {
    var checkVal = fomatterEN(e.target.value);
    setTextLastNameAboard(checkVal);
    if (!isEmpty(checkVal)) {
      setTextLastNameAboardError("");
    }
  };

  const handleChangeAboardName = (e) => {
    var checkVal = fomatterEN(e.target.value).replaceAll(/\s/g, "");
    setTextNameAboard(checkVal);
    if (!isEmpty(checkVal)) {
      setTextNameAboardError("");
    }
  };

  const handleChangePassport = (e) => {
    var checkVal = e.target.value.replace(/[^A-Za-z0-9]/g, "");
    setTextPassport(checkVal);
    if (!isEmpty(checkVal)) {
      if (checkVal.length < 7) {
        setTextPassportError("หมายเลขพาสปอส ขั้นต่ำ 7 หลัก");
      } else {
        setTextPassportError("");
      }
    } else {
      setTextPassportError("");
    }
  };

  const handleChangeLastNameSpouseThaiEn = (e) => {
    var checkVal = fomatterEN(e.target.value);
    setTextLastNameThaiEn(checkVal);
    if (!isEmpty(e.target.value)) {
      setTextLastNameThaiEnError("");
      setIsEnabled(true);
    } else {
      setIsEnabled(false);
    }
  };

  const handleChangeNameSpouseThaiEn = (e) => {
    var checkVal = fomatterEN(e.target.value).replaceAll(/\s/g, "");
    setTextNameThaiEn(checkVal);
    if (!isEmpty(e.target.value)) {
      setTextNameThaiEnError("");
    } else {
      setTextNameThaiEn("");
    }
  };

  const handleChangeLastNameSpouseThai = (e) => {
    if (!isEmpty(e.target.value)) {
      var checkVal = fomatterTH(e.target.value);
      setTextLastNameThai(checkVal);
      setTextLastNameThaiError("");
    } else {
      setTextLastNameThai("");
    }
  };

  const handleChangePrefix = (e) => {
    setprefix(e.target.value);
  };

  const handleChangeIdendityCard = (e) => {
    if (!isEmpty(e.target.value)) {
      var checkVal = e.target.value.replace(/[^0-9]/g, "");
      setTextIdendityCard(checkVal);
      setIsEnabled(true);
    } else {
      setTextIdendityCard("");
      setIsEnabled(false);
    }
  };

  const handleChangeNameSpouseThai = (e) => {
    if (!isEmpty(e.target.value)) {
      var checkVal = fomatterTH(e.target.value).replaceAll(/\s/g, "");
      setTextNameThai(checkVal);
      setTextNameThaiError("");
    } else {
      setTextNameThai("");
    }
  };
  const handleChangeStatusMarried = (event) => {
    const val = event.target.value;
    if (val == "married") {
      setSingle(false);
      setChecked(false);
    }
    if (val == "single") {
      setSingle(true);
      setChecked(true);
    }

    setValueSpouse("");
    setValue(event.target.value);
  };
  const handleChangeSpouse = (event) => {
    const val = event.target.value;
    //setChecked(true);
    if (val == "thai") {
      setisSpouseThai(true);
      setisSpouseAbroad(false);
    }
    if (val == "abroad") {
      setisSpouseThai(false);
      setisSpouseAbroad(true);
    }
    setCardId("");
    setTextIdendityCard("");
    setTextNameThai("");
    setTextLastNameThai("");
    setTextNameThaiEn("");
    setTextLastNameThaiEn("");
    setTextPassport("");
    setTitleAboard("");
    setTextNameAboard("");
    setTextLastNameAboard("");
    setValueAutoComplateEN(null);
    setValueAutoComplate(null);
    setCardIdError("");
    setTitleTextENError("");
    setTitleENError("");
    setTextNameThaiError("");
    setTextLastNameThaiError("");
    setTitleThai("");
    setTitleTextTHError("");
    setTextNameThaiEnError("");
    setTextLastNameThaiEnError("");
    setTitleTHError("");
    setTextPassportError("");
    setTextNameAboardError("");
    setTextLastNameAboardError("");
    setValueSpouse(event.target.value);
  };
  useEffect(() => {
    if (valueSpouse === "thai") {
      if (
        !isEmpty(cardId) &&
        !isEmpty(textNameThai) &&
        !isEmpty(textLastNameThai) &&
        !isEmpty(textNameThaiEn) &&
        !isEmpty(textLastNameThaiEn) &&
        !isEmpty(valueAutoComplate)
      ) {
        setChecked(true);
      } else {
        setChecked(false);
      }
    } else if (valueSpouse === "abroad") {
      if (
        !isEmpty(textPassport) &&
        !isEmpty(valueAutoComplateEN) &&
        !isEmpty(textNameAboard) &&
        !isEmpty(textLastNameAboard)
      ) {
        setChecked(true);
      } else {
        setChecked(false);
      }
    }
  }, [
    cardId,
    textNameThai,
    textLastNameThai,
    textNameThaiEn,
    textLastNameThaiEn,
    textPassport,
    textIdendityCard,
    titleAboard,
    textNameAboard,
    textLastNameAboard,
    valueSpouse,
    valueAutoComplate,
    valueAutoComplateEN,
  ]);

  return (
    <>
      {jumpPage ? (
        <Grid className="app-splash-screen"></Grid>
      ) : (
        <>
          <HeaderPage
            title={translations?.[lang]?.Married?.title}
            onChangeLang={(e) => setLang(e)}
            clickBack={(e) => (e ? props.history.push("/suit_result") : "")}
          />
          <Loading status={isLoading} />
          <Grid className="background-bg">
            <Grid className="section-consent">
              <Grid className={isMobile ? "box-content-mb" : "box-content"}>
                <Grid container className="box-content-main" columns={16}>
                  {!isMobile && (
                    <Grid item xs={7} className="box-left">
                      <BoxLeftContent
                        translations={translations?.[lang]?.Married}
                        clickBack={(e) => props.history.push("/suit_result")}
                        editUrl={editUrl}
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={mb}
                    className={isMobile ? "box-right-mb" : "box-right"}
                  >
                    <Grid className="content">
                      <Grid className="content-main">
                        <Grid
                          className="box-right-content pb-3"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                          }}
                        >
                          {" "}
                          <HeaderRight title="สถานภาพทางครอบครัว" />
                          <ScrollBarComponent
                            content={
                              <Grid className="mg-all-0-px">
                                <Grid className="sub-title">
                                  <Typography className="box-title text-left font-20">
                                    สถานภาพการสมรส
                                  </Typography>
                                </Grid>
                                <Grid className="btn-box fullWidth mg-left-10-p">
                                  <RadioGroup
                                    aria-label="gender"
                                    name="controlled-radio-buttons-group"
                                    value={value}
                                    onChange={handleChangeStatusMarried}
                                    className="fullWidth"
                                  >
                                    <FormControlLabel
                                      value="single"
                                      control={<Radio />}
                                      label={single}
                                    />
                                    <Divider />
                                    <FormControlLabel
                                      value="married"
                                      control={<Radio />}
                                      label={married}
                                    />
                                    {(value === "single" || value === "") && (
                                      <Divider />
                                    )}
                                  </RadioGroup>
                                </Grid>
                                {value === "married" && (
                                  <Grid>
                                    <Grid className="sub-title">
                                      <Typography className="box-title text-left font-20">
                                        {titleSpouse}
                                      </Typography>
                                    </Grid>
                                    <Grid className="btn-box fullWidth">
                                      <RadioGroup
                                        aria-label="gender"
                                        name="controlled-radio-buttons-group"
                                        value={valueSpouse}
                                        onChange={handleChangeSpouse}
                                        className="fullWidth"
                                      >
                                        <FormControlLabel
                                          value="thai"
                                          control={<Radio />}
                                          label={spouseThai}
                                          className="fullWidth spouse"
                                        />
                                        {valueSpouse === "thai" && (
                                          // <Grid className="mg-left-30-p mg-left-10-p">
                                          <Grid className="pd-left-30-p fullWidth">
                                            <Grid className="input-form ">
                                              <FormControl
                                                fullWidth
                                                variant="standard"
                                                error
                                              >
                                                <TextField
                                                  fullWidth
                                                  id="input_idenditycard"
                                                  variant="standard"
                                                  value={cardId || ""}
                                                  label={labelCardId}
                                                  inputProps={{
                                                    inputMode: "numeric",
                                                    pattern: "[0-9]-*",
                                                  }}
                                                  placeholder={hitRequire}
                                                  onChange={(e) =>
                                                    cardIdChange(e.target.value)
                                                  }
                                                  required
                                                />
                                                <FormHelperText className="text-error">
                                                  {cardIdError}
                                                </FormHelperText>
                                              </FormControl>
                                            </Grid>
                                            <Grid className="input-form">
                                              <FormControl
                                                fullWidth
                                                variant="standard"
                                                error
                                              >
                                                <Autocomplete
                                                  size="small"
                                                  options={options}
                                                  value={valueAutoComplate}
                                                  onChange={(e, val) =>
                                                    handleChangeTHTitle(e, val)
                                                  }
                                                  isOptionEqualToValue={(
                                                    option,
                                                    value,
                                                  ) => option.id === value.id}
                                                  getOptionLabel={(options) =>
                                                    options.NameTH
                                                      ? lang === "th"
                                                        ? options.NameTH
                                                        : options.NameEN
                                                      : ""
                                                  }
                                                  renderInput={(params) => (
                                                    <TextField
                                                      {...params}
                                                      variant="standard"
                                                      label={"คำนำหน้าชื่อ"}
                                                      required
                                                    />
                                                  )}
                                                  required
                                                />

                                                <FormHelperText className="text-error">
                                                  {titleTHError}
                                                </FormHelperText>
                                              </FormControl>
                                              {valueAutoComplate?.Other ===
                                                1 && (
                                                <Grid className="input-form ">
                                                  <FormControl
                                                    fullWidth
                                                    variant="standard"
                                                    error
                                                  >
                                                    <TextField
                                                      fullWidth
                                                      variant="standard"
                                                      value={titleThai}
                                                      label={"คำนำหน้าอื่นๆ"}
                                                      placeholder={hitRequire}
                                                      onChange={
                                                        prefixTextThaiAutherChange
                                                      }
                                                      required
                                                    />
                                                    <FormHelperText className="text-error">
                                                      {titleTextTHError}
                                                    </FormHelperText>
                                                  </FormControl>
                                                </Grid>
                                              )}
                                            </Grid>
                                            <Grid className="input-form ">
                                              <FormControl
                                                fullWidth
                                                variant="standard"
                                                error
                                              >
                                                <TextField
                                                  fullWidth
                                                  variant="standard"
                                                  value={textNameThai}
                                                  label={labelNameThai}
                                                  placeholder={hitRequire}
                                                  onChange={
                                                    handleChangeNameSpouseThai
                                                  }
                                                  required
                                                />
                                                <FormHelperText className="text-error">
                                                  {textNameThaiError}
                                                </FormHelperText>
                                              </FormControl>
                                            </Grid>
                                            <Grid className="input-form ">
                                              <FormControl
                                                fullWidth
                                                variant="standard"
                                                error
                                              >
                                                <TextField
                                                  fullWidth
                                                  variant="standard"
                                                  value={textLastNameThai}
                                                  label={labelLastNameThai}
                                                  placeholder={hitRequire}
                                                  onChange={
                                                    handleChangeLastNameSpouseThai
                                                  }
                                                  onBlur={(e) =>
                                                    setTextLastNameThai(
                                                      e.target.value.trim(),
                                                    )
                                                  }
                                                  required
                                                />
                                                <FormHelperText className="text-error">
                                                  {textLastNameThaiError}
                                                </FormHelperText>
                                              </FormControl>
                                            </Grid>
                                            <Grid className="input-form ">
                                              <FormControl
                                                fullWidth
                                                variant="standard"
                                                error
                                              >
                                                <TextField
                                                  fullWidth
                                                  variant="standard"
                                                  value={textNameThaiEn}
                                                  label={labelNameEng}
                                                  placeholder={hitRequire}
                                                  onChange={
                                                    handleChangeNameSpouseThaiEn
                                                  }
                                                  required
                                                />
                                                <FormHelperText className="text-error">
                                                  {textNameThaiEnError}
                                                </FormHelperText>
                                              </FormControl>
                                            </Grid>
                                            <Grid className="input-form ">
                                              <FormControl
                                                fullWidth
                                                variant="standard"
                                                error
                                              >
                                                <TextField
                                                  fullWidth
                                                  variant="standard"
                                                  value={textLastNameThaiEn}
                                                  label={labelLastNameEng}
                                                  placeholder={hitRequire}
                                                  onChange={
                                                    handleChangeLastNameSpouseThaiEn
                                                  }
                                                  onBlur={(e) =>
                                                    setTextLastNameThaiEn(
                                                      e.target.value.trim(),
                                                    )
                                                  }
                                                  required
                                                />
                                                <FormHelperText className="text-error">
                                                  {textLastNameThaiEnError}
                                                </FormHelperText>
                                              </FormControl>
                                            </Grid>
                                          </Grid>
                                        )}
                                        {valueSpouse !== "thai" && <Divider />}
                                        <FormControlLabel
                                          value="abroad"
                                          control={<Radio />}
                                          label={spouseAbroad}
                                          className="fullWidth"
                                        />
                                        {valueSpouse === "abroad" && (
                                          <Grid className="pd-left-30-p">
                                            <Grid className="input-form ">
                                              <FormControl
                                                fullWidth
                                                variant="standard"
                                                error
                                              >
                                                <TextField
                                                  fullWidth
                                                  variant="standard"
                                                  value={textPassport}
                                                  label={labelPassport}
                                                  inputProps={
                                                    {
                                                      // inputMode: "numeric",
                                                      // pattern: "[0-9]*",
                                                    }
                                                  }
                                                  placeholder={hitRequire}
                                                  onChange={
                                                    handleChangePassport
                                                  }
                                                  required
                                                />
                                                <FormHelperText className="text-error">
                                                  {textPassportError}
                                                </FormHelperText>
                                              </FormControl>
                                            </Grid>

                                            {/* Dropdown list prefix */}
                                            <Grid className="input-form">
                                              <FormControl
                                                fullWidth
                                                variant="standard"
                                                error
                                              >
                                                <Autocomplete
                                                  size="small"
                                                  options={options}
                                                  value={valueAutoComplateEN}
                                                  onChange={handleChangeENTitle}
                                                  isOptionEqualToValue={(
                                                    option,
                                                    value,
                                                  ) => option.id === value.id}
                                                  getOptionLabel={(options) =>
                                                    options.NameTH
                                                      ? lang === "th"
                                                        ? options.NameTH
                                                        : options.NameEN
                                                      : ""
                                                  }
                                                  renderInput={(params) => (
                                                    <TextField
                                                      {...params}
                                                      variant="standard"
                                                      label={"คำนำหน้าชื่อ"}
                                                      required
                                                    />
                                                  )}
                                                />

                                                <FormHelperText className="text-error">
                                                  {titleENError}
                                                </FormHelperText>
                                              </FormControl>
                                              {valueAutoComplateEN?.Other ===
                                                1 && (
                                                <Grid className="input-form ">
                                                  <FormControl
                                                    fullWidth
                                                    variant="standard"
                                                    error
                                                  >
                                                    <TextField
                                                      fullWidth
                                                      variant="standard"
                                                      value={titleAboard}
                                                      label={"คำนำหน้าอื่นๆ"}
                                                      placeholder={hitRequire}
                                                      onChange={
                                                        prefixTextEnAutherChange
                                                      }
                                                      required
                                                    />
                                                    <FormHelperText className="text-error">
                                                      {titleTextENError}
                                                    </FormHelperText>
                                                  </FormControl>
                                                </Grid>
                                              )}
                                            </Grid>
                                            <Grid className="input-form ">
                                              <FormControl
                                                fullWidth
                                                variant="standard"
                                                error
                                              >
                                                <TextField
                                                  fullWidth
                                                  variant="standard"
                                                  value={textNameAboard}
                                                  label={labelNameEng}
                                                  placeholder={hitRequire}
                                                  onChange={
                                                    handleChangeAboardName
                                                  }
                                                  required
                                                />
                                                <FormHelperText className="text-error">
                                                  {textNameAboardError}
                                                </FormHelperText>
                                              </FormControl>
                                            </Grid>
                                            <Grid className="input-form ">
                                              <FormControl
                                                fullWidth
                                                variant="standard"
                                                error
                                              >
                                                <TextField
                                                  fullWidth
                                                  variant="standard"
                                                  value={textLastNameAboard}
                                                  label={labelLastNameEng}
                                                  placeholder={hitRequire}
                                                  onChange={
                                                    handleChangeAboardLastName
                                                  }
                                                  onBlur={(e) =>
                                                    setTextLastNameAboard(
                                                      e.target.value.trim(),
                                                    )
                                                  }
                                                  required
                                                />
                                                <FormHelperText className="text-error">
                                                  {textLastNameAboardError}
                                                </FormHelperText>
                                              </FormControl>
                                            </Grid>
                                          </Grid>
                                        )}
                                        {valueSpouse !== "abroad" && (
                                          <Divider />
                                        )}
                                      </RadioGroup>
                                    </Grid>
                                  </Grid>
                                )}
                              </Grid>
                            }
                          />{" "}
                          <Grid className="btn-box">
                            <Button
                              className={clsx(
                                !checked
                                  ? "disabled-btn-right"
                                  : "enabled-btn-right",
                                "btn-primary font-20",
                              )}
                              disabled={!checked}
                              onClick={(e) => handleNext(e)}
                            >
                              {editUrl
                                ? translations?.[lang]?.Married?.summary
                                : translations?.[lang]?.Married?.next}
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <DialogWait
            open={isModelWait}
            isModel={setIsModelWait}
            title={"ขออภัย"}
            massage={message_error}
            btn={"ตกลง"}
          />
        </>
      )}
    </>
  );
};
export default memo(Married);
